import script from "./PedidoPaso1.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoPaso1.vue?vue&type=script&setup=true&lang=js"

import "./PedidoPaso1.vue?vue&type=style&index=0&id=f23ea14c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f23ea14c"]])

export default __exports__